'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';

export default function JobLookupError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Keep the operational signal without exposing internals to candidates.
    // eslint-disable-next-line no-console
    console.error('[job-detail-unavailable]', error.digest || error.message);
  }, [error]);

  return (
    <main
      data-vhire-job-unavailable="true"
      className="mx-auto flex min-h-[55vh] max-w-2xl flex-col items-center justify-center px-4 py-16 text-center"
    >
      <h1 className="text-2xl font-semibold">This job is temporarily unavailable</h1>
      <p className="mt-3 text-muted-foreground">
        We could not confirm the latest posting details. The role has not been marked as removed.
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Button onClick={reset}>Try again</Button>
        <Button asChild variant="outline">
          <Link href="/jobs">Browse jobs</Link>
        </Button>
      </div>
    </main>
  );
}
